import { z } from 'zod';
import campaignConfigSchema from './CampaignConfig.schema';
import { COMMS_TYPES, ITERATION_TYPES } from './enums/iterations';
import iterationRuleSchema from './IterationRule.schema';
import UserInfoSchema from './UserInfo.schema';

export const IterationCohortsApiSchema = z.object({
  CohortLabel: z.string().optional(),
  Description: z.string().optional(),
  Priority: z.number().optional(),
});

export const IterationDetailsApiSchema = z.object({
  ID: z.string().optional(),
  DefaultCommsRouting: z.string().optional(),
  Version: z.number().optional(),
  Name: z.string().optional(),
  IterationDate: z.string().optional(),
  IterationNumber: z.number().optional(),
  CommsType: z.enum(COMMS_TYPES).optional(),
  ApprovalMinimum: z.number().optional(),
  ApprovalMaximum: z.number().optional(),
  Type: z.enum(ITERATION_TYPES).optional(),
  IterationCohorts: z.array(IterationCohortsApiSchema).optional(),
  IterationRules: z.array(iterationRuleSchema).optional(),
});

export type IterationDetailsApi = z.infer<typeof IterationDetailsApiSchema>;

export enum ITERATION_STATUS {
  DRAFT = 'draft',
  IN_REVIEW = 'in review',
  REJECTED = 'rejected',
  APPROVED = 'approved',
  REPORT_REQUESTED = 'report requested',
  REPORT_READY = 'report ready',
  REPORT_IN_REVIEW = 'report in review',
  REPORT_REJECTED = 'report rejected',
  REPORT_APPROVED = 'report approved',
  SENT_TO_NHS_NOTIFY = 'sent to nhs notify',
  ARCHIVED = 'archived',
}

const iterationStatusSchema = z
  .string()
  .toLowerCase()
  .pipe(
    z.nativeEnum(ITERATION_STATUS),
  );

export const IterationApiSchema = z.object({
  iteration_details: IterationDetailsApiSchema.optional(),
  locked_by: UserInfoSchema.optional(),
  created_by: UserInfoSchema,
  creation_timestamp: z.number(),
  last_modified_by: UserInfoSchema,
  last_modified_timestamp: z.number(),
  status: iterationStatusSchema,
  submitted_by: z.string().optional(),
  reviewers: z.array(z.string()).optional(),
});

export type IterationApi = z.infer<typeof IterationApiSchema>;

export const campaignApiDetailsSchema = z.object({
  campaign: campaignConfigSchema([]),
  iterations: z.array(IterationApiSchema),
});

export type CampaignApiDetails = z.infer<typeof campaignApiDetailsSchema>;
